import React   from 'react' ;
import PageCh16_t1 from './pageCh16_t1';
const   PageCh16 = ()=>{
     
       
    return (
      <>  <hr/> 
      <h1 className="m-2" >PageCh16 (chapter 16  Working with Forms & User Input)</h1>
       <PageCh16_t1 />     
      </>
    )
     
} 
export default PageCh16
